import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Model_Synchronisation } from './app.models';

@Injectable()
export class SynchronisationService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doInitSynchronisationAction(_synchronisation: Model_Synchronisation) {
        return this._httpClient.post<Model_Synchronisation>(this._apiService.endPoints.doInitSynchronisationAction_Synchronisation, _synchronisation)
    }

    doProcessSynchronisationTaskAction(_guidSyncTask: string, _syncDatas: any) {
        return this._httpClient.post<Model_Synchronisation>(this._apiService.endPoints.doProcessSynchronisationTaskAction_Synchronisation, { GUID_SYNCHRONISATION_TASK: _guidSyncTask, SYNCHRONISATION_DATAS: _syncDatas });
    }
}